import { types as api } from '@mesa-labs/mesa-api';
import React from 'react';
import styled from 'styled-components';

import Linkified from './Linkified';
import { formatMonthDay } from '../../../../utils';
import { formatOperatorEmail } from '../../../../utils/permissionUsers';

const Quote = styled.blockquote<{ $maxHeight?: number }>`
  background: #F9FAFB;
  border-left: 3px solid ${(p) => p.theme.colors.Gray300};
  border-radius: 4px;
  color: ${(p) => p.theme.colors.Gray700};
  font-size: 12px;
  margin: 0;
  ${(p) => p.$maxHeight && `max-height: ${p.$maxHeight}px; overflow-y: auto;`}
  padding: 6px 10px;
  white-space: pre-wrap;
`;

const Meta = styled.div`
  color: ${(p) => p.theme.colors.Gray500};
  font-size: 11px;
  margin-bottom: 2px;
`;

type Props = {
  note: api.VendorNoteResponse;
  // Scrolls long Notes in tight spaces such as the create forms.
  maxHeight?: number;
};

// The Note an Action Item was (or is being) created from.
export default function SourceNoteQuote({ note, maxHeight }: Props): React.ReactElement {
  return (
    <Quote $maxHeight={maxHeight}>
      <Meta>{`${formatOperatorEmail(note.createdBy)} · ${formatMonthDay(note.createdAt)}`}</Meta>
      <Linkified text={note.note} />
    </Quote>
  );
}
